import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

export function useToken(): () => Promise<string> {
  const { accounts, instance } = useMsal();

  return async function getToken(): Promise<string> {
    const account = accounts[0];
    if (!account) {
      await instance.loginRedirect({ scopes: ['openid', 'profile'] });
      throw new Error('Redirecting to login');
    }
    try {
      const result = await instance.acquireTokenSilent({
        account,
        scopes: ['openid', 'profile'],
      });
      return result.idToken;
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError || err instanceof BrowserAuthError) {
        await instance.loginRedirect({ scopes: ['openid', 'profile'] });
        throw new Error('Redirecting to login');
      }
      throw err;
    }
  };
}
